import { render, staticRenderFns } from "./WhatsAppTemplate.vue?vue&type=template&id=fae6f17a"
import script from "./WhatsAppTemplate.vue?vue&type=script&lang=js"
export * from "./WhatsAppTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports